<button app-add-button
  class="atlas-btn atlas-btn-secondary"
  [disabled]="updatingEvent"
  [label]="'events.dashboard.component.new-registration-label' | translate | titlecase"
  (onClick)="newRegistration()"
>
</button>
<!--hidden by default as this is a modal-->
<wl-registration-wizard #registrationWizard (onRegistrationSaved)="registrationSaved($event)"></wl-registration-wizard>
